import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomerSiteAdministrationControllerService } from '@app/generated/api';
import { CustomerSiteDto } from '@app/generated/model';
import { buildCustomerSiteForm } from './customer-site-form-builder';

@Component({
  selector: 'app-add-customer-site',
  templateUrl: './add-customer-site.component.html',
  styleUrls: ['./add-customer-site.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddCustomerSiteComponent {
  form: UntypedFormGroup;

  constructor(
    formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddCustomerSiteComponent>,
    private customerSiteService: CustomerSiteAdministrationControllerService,
  ) {
    this.form = buildCustomerSiteForm(formBuilder);
  }

  onAdd(): void {
    if (!this.form.valid) {
      return;
    }

    const customerSite = this.form.getRawValue() as CustomerSiteDto;
    this.customerSiteService.createCustomerSite(customerSite).subscribe({
      next: () => this.dialogRef.close(true),
      error: (err) => console.error('Error adding customer site:', err),
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
